<template>
  <div>
    <AddPackage update @update="updatePackage = !updatePackage" :key="updatePackage" />
    <Toast title="بروزرسانی با موفقیت انجام شد" :showToast="showToast" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import AddPackage from '../../../components/dadban/packages/AddPackage.vue'
import Toast from '../../../components/common/Toast.vue'
export default {
  page: {
    title: 'ویرایش بسته',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-edit-packages',
  data() {
    return {
      updatePackage: false,
      showToast: false,
    }
  },
  watch: {
    updatePackage() {
      this.updateToast()
    },
  },
  methods: {
    updateToast() {
      this.showToast = true
    },
  },
  components: {
    AddPackage,
    Toast,
  },
}
</script>
